import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import PlusSvg from '@/assets/Plus.svg';

const PlusIcon = ({ size, variant, className }: IconProps) => (
  <img
    src={PlusSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default PlusIcon;
